const UrlConfigs = {
    baseUrl: 'https://kewgreen.360cloudsecure.com/api/',
    //baseUrl: 'https://32ed3a523b08.ngrok.app/api/',
    mapBox:  'pk.eyJ1Ijoic3JpbmF0aHJhamEiLCJhIjoiY2xmOXI1OGNmMXMyMzQwbzRsOGl4bGtlaSJ9.0kVoKyk3RDsxxgfLhdcRHw',
    mapStyle: 'mapbox://styles/mapbox/streets-v11',
};


export default UrlConfigs;
  